import moment from "moment";

/**
 * 格式化时间格式
 * @param dateStr       目标格式化内容
 * @param formatStr 格式化格式，默认值为"YYYY-MM-DD HH:mm:ss"
 * @returns {string}
 */
function timeFormat(dateStr, formatStr = "YYYY-MM-DD HH:mm:ss") {
    if (!dateStr) return "";
    return moment(parseInt(dateStr) * 1000).format(formatStr);
}

/**
 * 值为空时，格式化为“——”
 * @param {*} value 
 */
function nullFormat(value) {
    return value ? value : '——';
}

/**
 * 千分位过滤器
 * @param amount    金额
 * @returns {Number, String}
 */
function numFormat(amount) {
    let val = typeof (amount) === 'number' ? amount : +amount

    return (val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
}

export default {
    timeFormat,
    nullFormat,
    numFormat
}



// WEBPACK FOOTER //
// ./src/common/filters.js